/**
 * The platform's authority names, mirroring the server's `RoleType` enum.
 *
 * <p>Centralised here because these strings were previously repeated as literals across
 * `AuthContext` and the service modules, where a typo fails silently (a role check that is simply
 * always false). Import from here rather than re-typing them.
 */
export const ROLES = {
  SYSTEM_ADMIN: "SYSTEM_ADMIN",
  COMPANY_GROUP_ADMIN: "COMPANY_GROUP_ADMIN",
  ADMIN: "ADMIN",
  /** Delegated company authority: above a trainer, up to (never above) a company admin. */
  MANAGER: "MANAGER",
  TRAINER: "TRAINER",
  TRAINEE: "TRAINEE",
  USER: "USER",
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

/**
 * The authorities allowed to sign in to the admin dashboard at all. A user holding none of these
 * (a plain TRAINEE, or a roleless account) is rejected at login — the mobile app is their surface.
 */
export const ADMIN_APP_ROLES: Role[] = [
  ROLES.SYSTEM_ADMIN,
  ROLES.COMPANY_GROUP_ADMIN,
  ROLES.ADMIN,
  ROLES.MANAGER,
  ROLES.TRAINER,
];
